export default __webpack_public_path__ + "b771473ffe26f4cf189b6d85db22abb5.png";